import { Col, Modal, Row, Space } from "antd";
import { useEffect } from "react";
import { inviteIcon } from "../../../assets/icons";
import { redCross, greenTick } from "../../../assets/images";
import { ModalType } from "../../../config/enum";
import { UIbutton, UIsecondaryButton } from "../button";
import "./style.css"

export const UIConfirmModal = (props: any) => {
  const {
    type,
    primaryText,
    visible,
    confirmButton,
    cancelButton,
    confirmCallback,
    cancelCallback,
    className,
    cancelSiteButton,
    btnType,
    form,
    iconNode
  } = props;  

  const handleCancel = () => {
    if (cancelSiteButton) {
      cancelSiteButton();
    } else if (cancelCallback) {
      cancelCallback();
    }
  };

  useEffect(() => {
    if (!visible) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (confirmCallback) {
          confirmCallback();
        }
      } else if (event.key === "Escape") {
        event.preventDefault();
        handleCancel();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [visible, confirmCallback, cancelSiteButton, cancelCallback]);

  const getIconType:any = () => {
    if (type === ModalType.WARN) return redCross;
    else if (type === ModalType.INVITE) return inviteIcon;
    else if (type === false) return null;
    else return greenTick;
  };

  const altText: any = () => {
    if (type === ModalType.WARN) return "redCross";
    else if (type === ModalType.INVITE) return "inviteIcon";
    else if (type === false) return "";
    else return "greenTick";
  }

  return (
    <Modal
      wrapClassName={className ? `${className} modalClass` : "modalClass"}
      visible={visible}
      onCancel={handleCancel}
      centered
      footer={null}
      closable={false}
    >
      {props.children}
      <Row justify="center">
        <Col>
          {iconNode ? (
            <span className="confirm-modal-icon">{iconNode}</span>
          ) : (
            <img className="redCoss" src={getIconType()} alt={altText()} />
          )}
        </Col>
      </Row>
      <Row justify="center">
        <Col xl={24}>
          <div className="primaryText">
            <span>{primaryText}</span>
          </div>
        </Col>
      </Row>
      <Row justify="center">
        <Space size={20}>
          <Col span={24}>
          <UIsecondaryButton onPress={cancelSiteButton ? cancelSiteButton : cancelCallback}>
            {cancelButton}
          </UIsecondaryButton>
          </Col>
          <Col span={24}>
          <UIbutton type="info" btnType={btnType ? btnType : null} form={form} onPress={confirmCallback}>
            {confirmButton}
          </UIbutton>
          </Col>
        </Space>
      </Row>
    </Modal>
  );
};
